import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOpcoUserDetailsPath = (id: string = ':id') => urlHelper(`/opco-users/${id}/details`);
